import type { Quartier } from '~/api/gen'

/** Quartiers IRIS du datalake par code INSEE : Guéret en a, Arnac-Pompadour (rural) aucun. */
export const quartiersParCommune: Record<string, Quartier[]> = {
  23096: [
    { oid: 'iris_230960202', nom: 'Champegaud' },
    { oid: 'iris_230960201', nom: 'Maindigour' },
  ],
}
